import { http } from "../http";

export interface InTransfer {
    trnRequestType: string;
    PMTCUSTID: string;
    CUSTACC: string;
    CUSTCIF: string;
    AMOUNT: number;
    BENEFACC: string;
    PMTDET: string;
    COMMAMOUNT: number;
    BENEFACCTYPE: string;
    NOTE: string;
};


export const newTransfer = async (transfer: InTransfer): Promise<InTransfer> => {
    const { data } = await http.post<InTransfer>("moneytransfer/intransfer-edv", transfer);
    return data;
};

